module.exports = __webpack_public_path__ + "static/media/icn_zero_paper.f3d817d5.svg";